export function normalizeNavPath(path: string) {
  if (path.length > 1 && path.endsWith('/')) {
    return path.slice(0, -1);
  }
  return path;
}

export function isNavLinkActive(pathname: string, to: string) {
  return normalizeNavPath(pathname) === normalizeNavPath(to);
}
